import React from 'react'
import { createRoot } from 'react-dom/client'

import MuiSchemaBuyflow from '../common/components/MuiSchemaBuyflow'

const root = createRoot(document.getElementById('module-window'))
root.render(<MuiSchemaBuyflow />)
